import { render, staticRenderFns } from "./Def.vue?vue&type=template&id=fb73076c&scoped=true"
import script from "./Def.vue?vue&type=script&lang=js"
export * from "./Def.vue?vue&type=script&lang=js"
import style0 from "./Def.vue?vue&type=style&index=0&id=fb73076c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb73076c",
  null
  
)

export default component.exports